export const RECLUTAMIENTO = "https://api-reclutamiento-test.cydocs.cl";
export const ADMINISTRACION_USUARIOS = "https://api-usuarios.cydocs.cl";
export const LOGIN = "https://account.cydocs.cl";
export const PORTAFOLIO = "https://api-portafolio.cydocs.cl";
export const PROYECTOS = "https://api-proyecto.cydocs.cl";
export const REDIRECT_BASE = "https://api-usuarios.cydocs.cl/login";
export const STORAGE = "https://storage.cydocs.cl";
export const EMAIL_API_URL = "https://sendmail.cydocs.cl/email";